//local imports
import {
  BreadcrumbChangedMessage,
  IBreadcrumbItemModel,
  Messenger,
} from "@app/shared";
import {
  CatalogConstants,
  CategoryModel,
  DepartmentModel,
  ProgramModel,
  ProjectModel,
  RoomModel,
  CatalogStateService,
  RoomContentModel
} from "@app/catalog";
import { SearchModel } from "@app/core";

export class CatalogMenuStateHandler {

    private catalogStateService: CatalogStateService;
    private currentBreadcrumbs: IBreadcrumbItemModel[] = [];


    public initialize(
        catalogStateService: CatalogStateService, 
        messenger: Messenger) {

        this.catalogStateService = catalogStateService;

        messenger.subscribe(this, BreadcrumbChangedMessage, (msg) => {
            if(msg.breadcrumbName !== CatalogConstants.CATALOG) return;
            this.currentBreadcrumbs = msg.breadcrumbs;
            this.syncBreadcrumbsToMenu();
        });

    }

    public syncBreadcrumbsToMenu(): void {
        const menus = this.catalogStateService.CatalogManagementState.menus();

        const activeIds = new Map<any, string>();
        let activeSearchName: string | undefined;

        this.currentBreadcrumbs.forEach(item => {
            if (item instanceof SearchModel) {
                activeSearchName = item.name();
            } else {
                activeIds.set(item.constructor, (item as any).id);
            }
        });

        // Helper function to sync a menu collection
        const sync = (collection: any[], modelType: any) => {
            const targetId = activeIds.get(modelType);
            collection.forEach(item => item.isChecked.set(item.id === targetId));
        };

        sync(menus.rooms(), RoomModel);
        sync(menus.departments(), DepartmentModel);
        sync(menus.categories(), CategoryModel);
        sync(menus.programs(), ProgramModel);
        sync(menus.projects(), ProjectModel);
        sync(menus.roomContents(), RoomContentModel);
    }
}